// Imports
import Splide from '@splidejs/splide';
import Mmenu from 'mmenu-js';
import AOS from 'aos';
import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CountUp } from 'countup.js';

gsap.registerPlugin(MorphSVGPlugin, ScrollTrigger);

const $j = jQuery.noConflict();

//// Site functions ////

AOS.init({
    duration: 800,
    offset: 40
});

// Site menu
function siteMenu() {
    const menuBtn = document.querySelector('.menu-btn');
    const menu = document.querySelector('.navbar-menu');
    const html = document.body.parentNode;
    const nav = document.getElementById('site-navigation');

    menuBtn.addEventListener('click', function () {
        menuBtn.classList.toggle('opened');
        nav.classList.toggle('menu-open');

        if (menuBtn.classList.contains('opened')) {
            menuBtn.setAttribute('aria-expanded', 'true');
            menu.style.display = 'flex';
            html.style.overflow = 'hidden';
        } else {
            menuBtn.setAttribute('aria-expanded', 'false');
            menu.style.display = 'none';
            html.style.overflow = 'unset';
        }
    });
}

// MMENU
function navMmenu() {
    new Mmenu('#menu-inner', {
        offCanvas: {
            use: false
        },
        navbar: {
            title: ' ',
            titleLink: 'parent'
        },
        theme: 'dark'
    });
}

// navScrolled
function navScrolled() {
    let navBar = document.querySelector('#site-navigation');

    let navEvent = function () {
        let top = window.pageYOffset || document.documentElement.scrollTop;
        if (top > 100) {
            navBar.classList.add('scrolled');
        } else {
            navBar.classList.remove('scrolled');
        }
    };

    window.addEventListener('scroll', navEvent, false);
    window.addEventListener('load', navEvent, false);
}

// Smooth scroll
function smoothScroll() {
    const links = document.querySelectorAll("a[href*='#']:not([href='#']):not([href='#0'])");

    for (const link of links) {
        link.addEventListener('click', clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        const offsetTop = document.querySelector(href).offsetTop;

        scroll({
            top: offsetTop - 120,
            behavior: 'smooth'
        });
    }
}

//// Headers ////

function headerHome() {
    const wLeft = document.querySelector('svg#pn-logo-anim g#w-left'),
        wRight = document.querySelector('svg#pn-logo-anim g#w-right'),
        bLeft = document.querySelector('svg#pn-logo-anim path#b-left'),
        bRight = document.querySelector('svg#pn-logo-anim path#b-right'),
        animText = document.querySelector('.header-home__heading'),
        animSub = document.querySelector('.header-home__sub'),
        homeCheck = document.querySelector('#header-home');

    if (typeof homeCheck != 'undefined' && homeCheck != null) {
        const pnLogoAnim = gsap.timeline();

        // Anim delay start
        pnLogoAnim.delay(2);

        // Anim start
        pnLogoAnim.addLabel('start');
        pnLogoAnim.to(
            wLeft,
            {
                autoAlpha: 0
            },
            'start'
        );
        pnLogoAnim.to(
            wRight,
            {
                autoAlpha: 0
            },
            'start'
        );

        // Anim brackets
        pnLogoAnim.addLabel('brackets');

        pnLogoAnim.to(
            bLeft,
            {
                morphSVG: {
                    shape: '#t-left',
                    map: 'complexity'
                },
                ease: 'power4.inOut',
                duration: 1
            },
            'brackets'
        );

        pnLogoAnim.to(
            bRight,
            {
                morphSVG: {
                    shape: '#t-right',
                    map: 'complexity'
                },
                ease: 'power4.inOut',
                duration: 1
            },
            'brackets'
        );

        // Anim text
        pnLogoAnim.addLabel('heading');
        pnLogoAnim.fromTo(
            animText,
            {
                y: 100,
                autoAlpha: 0
            },
            {
                y: 0,
                autoAlpha: 1,
                ease: 'expo.out',
                duration: 1
            }
        );

        pnLogoAnim.to(
            animSub,
            {
                autoAlpha: 1
            },
            'heading'
        );
    } else {
        return;
    }
}

// Header "curious"
function headerCurious() {
    const curiousCheck = document.querySelector('#header-curious');

    if (typeof curiousCheck != 'undefined' && curiousCheck != null) {
        const fadeAnim = gsap.timeline();
        /* const question = gsap.timeline({
            paused: true,
            repeat: -1,
            yoyo: true
        }); */

        fadeAnim.fromTo(
            '.fade',
            {
                opacity: 0,
                delay: 1
            },
            {
                opacity: 1,
                stagger: 0.5,
                duration: 2
                /* onComplete: () => {
                    question.play(0);
                } */
            }
        );

        /* question.to('#question', {
            opacity: 0,
            duration: 1
        }); */
    } else {
        return;
    }
}

// Header "insightful"
function headerInsightful() {
    const insightfulCheck = document.querySelector('#header-insightful');

    if (typeof insightfulCheck != 'undefined' && insightfulCheck != null) {
        const fade = gsap.timeline();
        const hands = gsap.timeline({
            paused: true,
            repeat: -1,
            repeatDelay: 1
        });

        fade.to('#header-insightful .fade', {
            delay: 1,
            opacity: 1,
            stagger: 0.5,
            onComplete: () => {
                hands.play(0);
            }
        });

        hands.to('#header-insightful #Path_204', {
            duration: 0.5,
            rotation: 10,
            repeat: -1,
            yoyo: true
        });
        hands.to('#header-insightful #Path_205', {
            duration: 0.5,
            rotation: 10,
            repeat: -1,
            yoyo: true
        });
    }
}

//// Flexible content functions ////

// Results block
function flxResults() {
    let counters = document.querySelectorAll('.results__numbers');

    if (typeof counters != 'undefined' && counters != null) {
        counters.forEach(function (item) {
            let prefix = item.dataset.countupPrefix;
            let suffix = item.dataset.countupSuffix;
            let number = parseInt(item.dataset.countupNumber);

            let countup = new CountUp(item, number, {
                startVal: 0,
                prefix: prefix,
                suffix: suffix
            });

            ScrollTrigger.create({
                trigger: item,
                start: 'top 75%',
                onEnter: function () {
                    countup.start();
                }
            });
        });
    }
}

// Content Slider
function flxContentSlider() {
    let theSlider = document.querySelector('#content-slider__splide');

    if (typeof theSlider != 'undefined' && theSlider != null) {
        let cSlider = new Splide(theSlider, {
            type: 'slide',
            perPage: 3,
            breakpoints: {
                768: {
                    perPage: 1
                },
                1024: {
                    perPage: 2
                }
            },
            perMove: 1,
            padding: { left: '5vw', right: '5vw' },
            gap: '1rem'
        });
        cSlider.on('mounted', function () {
            AOS.refresh();
        });

        cSlider.mount();
    }
}

// Insights feed
function flxInsightsFeed() {
    let theSlider = document.querySelector('#insights-feed__splide');

    if (typeof theSlider != 'undefined' && theSlider != null) {
        let iFeed = new Splide(theSlider, {
            type: 'slide', // loop
            perPage: 3,
            breakpoints: {
                768: {
                    perPage: 1
                },
                1024: {
                    perPage: 2
                }
            },
            perMove: 1,
            padding: { left: '5vw', right: '5vw' },
            gap: '1rem'
        });

        iFeed.on('mounted', function () {
            AOS.refresh();
        });

        iFeed.mount();
    }
}

// Our projects Slider
function flxOurProjectsSplide() {
    let opSlider = document.querySelector('#our-projects__splide');

    if (typeof opSlider != 'undefined' && opSlider != null) {
        let ourPro = new Splide(opSlider, {
            type: 'loop',
            perPage: 1
            //autoplay: true
        });

        ourPro.on('mounted', function () {
            AOS.refresh();
        });

        ourPro.mount();
    }
}

// Our projects Slider
function logosSplide() {
    let logoSlider = document.querySelector('#logos__splide');

    if (typeof logoSlider != 'undefined' && logoSlider != null) {
        let logoS = new Splide(logoSlider, {
            type: 'loop',
            perPage: 2,
            mediaQuery: 'min',
            breakpoints: {
                600: {
                    perPage: 3
                },
                1024: {
                    perPage: 4
                }
            },
            perMove: 1,
            autoplay: true,
            arrows: false,
            pagination: false,
            gap: 40
        });

        logoS.on('mounted', function () {
            AOS.refresh();
        });

        logoS.mount();
    }
}

//// Utility functions ////

// DOM Ready
const DOMReady = function (callback) {
    if ('interactive' === document.readyState || 'complete' === document.readyState) {
        callback();
    } else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', callback());
    } else if (document.attachEvent) {
        document.attachEvent('onreadystatechange', function () {
            if ('loading' != document.readyState) {
                callback();
            }
        });
    }
};

//// Let's go! ////
DOMReady(function () {
    navScrolled();
    navMmenu();

    siteMenu();

    headerHome();
    headerCurious();
    headerInsightful();

    // Logos slider
    logosSplide();

    smoothScroll();

    // flx
    flxContentSlider();
    flxOurProjectsSplide();
    flxInsightsFeed();
    flxResults();

    $j(document).on('sf:ajaxfinish', '.searchandfilter', function () {
        AOS.refresh();
    });

    // Sorts out Lighthouse SEO issue for mmenu.js
    let mmenuNavbarTitle = document.querySelector('#menu-main > .mm-navbar > a.mm-navbar__title');
    mmenuNavbarTitle.setAttribute('href', '#');
});

//// Preloader ///
function handlePreloader() {
    const preloader = document.querySelector('#page-preloader');

    if (preloader.classList.contains('loaded')) {
        preloader.classList.remove('loaded');
    }
    setTimeout(function () {
        preloader.classList.add('loaded');
    }, 600);
}
window.addEventListener('load', handlePreloader);
